export class ButtonsTab {
    currentTab: string = 'Production';

    constructor() { }

    setCurrentTab(tabName: string) {
        this.currentTab = tabName;
    }
}
